export default __webpack_public_path__ + "static/media/gsm_2.516821f0.svg";